<template>
  <header
    :class="[extendHeader ? 'quiz-header-overlap' : 'quiz-header']"
    :style="{ background: isDarkTheme ? topBgColor : bgTheme }"
  >
    <div
      class="container-fluid"
      :style="{ background: isDarkTheme ? topBgColor : bgTheme }"
    >
      <ul>
        <li>
          <a
            class="h-back-link"
            data-toggle="modal"
            data-target=".exit-quiz-modal"
            v-on:click="handleBack()"
          >
            <!-- <img class="img-fluid" src="@/assets/back-light.png" alt="back" /> -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="none"
              :stroke="isDarkTheme ? headingTextColor : '#ffffff'"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
          </a>
          <span
            style="font-size: 18px; margin-bottom: 5px;"
            :style="{ color: isDarkTheme ? headingTextColor : '#ffffff' }"
          >
            Trivia</span
          >
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { globals } from "@/mixins/globals";
export default {
  mixins: [globals],
  name: "trivia-header",
  props: {
    title: String,
    showAddTask: Boolean,
    extendHeader: Boolean
  },
  components: {},
  methods: {
    handleBack() {
      var currentUrl = window.location.pathname;
      if (currentUrl == "/play-quiz") {
        this.$store.state.showExitModal = true;
        return;
      }
      this.$router.go(-1);
    }
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },
    homePage() {
      if (this.$route.path === "/") {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    document.documentElement.style.setProperty("--bg-color", this.bgTheme);
  }
};
</script>

<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";
@import "../assets/fonts/quiz-fonts/fonts.css";
</style>
